import { get } from 'api';

export const getReposList = (owner: string, project?: string | null | undefined) =>
  get({
    params: { project },
    url: `/${owner}/repos`,
  });
